import axios from '@/services/api';


export const getExperiences = async ({ commit }, params) => {
    commit('setExperiences', []);
    const response = await axios.get('/experiences', { params: params})

    const { data } = response;

    try {
        if (data) {
            commit('setExperiences', data);
        }

    } catch (e) {
        console.log(e);
    }

};

export const getExperienceById = async ({ commit }, id) => {
    commit('setCurrentExperience', null);
    const response = await axios.get(`/experiences/${id}`)

    const { data } = response;

    try {
        if (data) {
            commit('setCurrentExperience', data);
        }

    } catch (e) {
        console.log(e);
    }
}

export const add = async (_, payload) => {
    return await axios.post("experiences", payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const edit = async (_, payload) => {

    return await axios.put("experiences/" + payload.id, payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const deleteExperience = async (_, id) => {

    await axios.delete(`/experiences/${id}`)
        .then((response) => response)
        .catch((e) => e.response);

};

